import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, Users } from "lucide-react";
import { membersApi, sportsApi } from "@/lib/api";
import { PageContainer, SectionTitle, EmptyState, UserAvatar, SportChip } from "@/components/shared";
import { StaggerGroup, StaggerItem, SkeletonGrid } from "@/components/motion";
import { hoverLift } from "@/lib/motion";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function DirectoryPage() {
  const [members, setMembers] = useState([]);
  const [sports, setSports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [sportFilter, setSportFilter] = useState("all");

  useEffect(() => { sportsApi.list().then((r) => setSports(r.data)).catch(() => {}); }, []);
  useEffect(() => { (async () => { setLoading(true); try { const r = await membersApi.directory(sportFilter !== "all" ? sportFilter : undefined); setMembers(r.data); } finally { setLoading(false); } })(); }, [sportFilter]);

  const sportName = (id) => sports.find((s) => s.id === id)?.name;
  const sportColor = (id) => sports.find((s) => s.id === id)?.color;
  const filtered = members.filter((m) => `${m.first_name} ${m.last_name}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <PageContainer>
      <SectionTitle>Répertoire des membres actifs</SectionTitle>
      <p className="-mt-3 text-sm text-muted-foreground">Registre officiel et public de la communauté ASL, mis à jour en temps réel.</p>
      <div className="flex flex-wrap gap-3">
        <div className="relative flex-1 min-w-[200px]"><Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un membre…" className="pl-9" data-testid="repertoire-recherche-input" /></div>
        <Select value={sportFilter} onValueChange={setSportFilter}><SelectTrigger className="w-44" data-testid="repertoire-filtre-sport-select"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="all">Tous les sports</SelectItem>{sports.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent></Select>
      </div>

      {loading ? <SkeletonGrid count={6} /> : filtered.length === 0 ? <EmptyState title="Aucun membre actif" description="Les membres actifs apparaîtront ici." icon={Users} /> : (
        <StaggerGroup className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((m) => (
            <StaggerItem key={m.id}>
              <motion.div {...hoverLift}>
                <Link to={`/profil/${m.id}`}><Card data-testid="repertoire-membre-carte"><CardContent className="flex items-center gap-3 p-4">
                  <UserAvatar user={m} />
                  <div className="min-w-0 flex-1"><div className="truncate font-semibold">{m.first_name} {m.last_name}</div><div className="mt-1 flex flex-wrap gap-1">{(m.sports || []).map((sid) => sportName(sid) && <SportChip key={sid} name={sportName(sid)} color={sportColor(sid)} />)}</div></div>
                </CardContent></Card></Link>
              </motion.div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      )}
    </PageContainer>
  );
}
